import React, { useEffect, useRef, useMemo } from 'react';

import { getApplicableL2MyTeamModules } from 'Deer/components/navigation/secondary/MyTeam/MyTeamModules';
import { useDeerTeamType } from 'Deer/hooks/useDeerTeamType';
import { EngagementManageIntent } from 'Deer/intent/Engagement/EngagementManageIntent';
import { EngagementIntentDropdown } from 'Deer/intent/Engagement/components/EngagementIntentDropdown';
import { useSelectEngagementSelectedIntent } from 'Deer/intent/Engagement/slice/EngagementIntentSlice';
import { Layout } from 'Deer/intent/components/Layout/Layout';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { useDispatch } from 'react-redux';
import { setSelectedView, useSelectedView } from 'reducers/viewsSlice';

import { getPersistenceKey } from 'constants/helper';

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cohort: any;
}

const DirectReportsEngagementInsights = ({ cohort }: Props) => {
  const dispatch = useDispatch();
  const gridRef = useRef(null);
  const { moduleName } = useOrganisationSettings();
  const applicableL2DirectReportsModules = getApplicableL2MyTeamModules('directReports', moduleName);
  const applicableL2AllReportsModules = getApplicableL2MyTeamModules('allReports', moduleName);
  const teamType = useDeerTeamType();
  const { label: intentLabel } = useSelectEngagementSelectedIntent() ?? {};
  const cohortDetails = useSelectedView();
  /* Grid State persistence Key */
  const viewId = cohortDetails?.id;

  const gridStatePersistenceKey = useMemo(() => {
    const tabId = intentLabel;
    const uniqueId = 'EngagementAnalyticsGrid';

    return getPersistenceKey({
      moduleName,
      viewId,
      tabId,
      uniqueId,
    });
  }, [intentLabel, moduleName, viewId]);

  useEffect(() => {
    dispatch(setSelectedView({ ...cohort, teamId: cohort.id }));
    return () => {
      dispatch(setSelectedView({}));
    };
  }, [cohort, dispatch]);

  return (
    <Layout
      Filters={
        <EngagementIntentDropdown
          gridRef={gridRef}
          breadcrumbs={{
            items: [
              {
                label: teamType === 'allReports' ? 'Skip Team' : 'Direct Team',
                to:
                  teamType === 'allReports'
                    ? applicableL2AllReportsModules[0]?.value
                    : applicableL2DirectReportsModules[0]?.value,
              },
            ],
            page: {
              label: 'Engagement',
              to: '',
            },
          }}
        />
      }
    >
      <EngagementManageIntent gridStatePersistenceKey={gridStatePersistenceKey} gridRef={gridRef} />
    </Layout>
  );
};

export default DirectReportsEngagementInsights;
